import { ExerciseExistingBloc } from "@modules/sessionBlock/exercises/components/exerciseExistingBloc"
import { MediaExistingBloc } from "@modules/sessionBlock/media/components/mediaExistingBloc"
import { NoteForAthletesExistingBloc } from "@modules/sessionBlock/notes/components/noteForAthletesExistingBloc"
import { NoteForCoachesExistingBloc } from "@modules/sessionBlock/notes/components/noteForCoachesExistingBloc"
import { SessionBlockFormikType } from "@modules/sessionBlock/sessionBlockFormikTypes"
import { SessionBlockType } from "@modules/sessionBlock/sessionBlockTypes"

type Props = {
  block: SessionBlockFormikType
  blockIndex: number
} & React.HTMLAttributes<HTMLDivElement>

export const ExistingBlock: React.FC<Props> = ({ block, blockIndex, ...props }) => {
  return (
    <div {...props}>
      {/* Block content */}
      {block.type === SessionBlockType.SESSION_EXERCISE ? (
        <ExerciseExistingBloc block={block} blockIndex={blockIndex} />
      ) : block.type === SessionBlockType.COACH_NOTE ? (
        <NoteForCoachesExistingBloc block={block} blockIndex={blockIndex} />
      ) : block.type === SessionBlockType.MEDIAS ? (
        <MediaExistingBloc block={block} blockIndex={blockIndex} />
      ) : (
        <NoteForAthletesExistingBloc block={block} blockIndex={blockIndex} />
      )}
    </div>
  )
}
